var _g, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icomoon-ignore"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.999 2.672c-7.361 0-13.327 5.968-13.327 13.329s5.966 13.327 13.327 13.327c7.361 0 13.329-5.966 13.329-13.327s-5.968-13.329-13.329-13.329zM28.248 15.468h-9.562c0.102-3.663 1.248-7.144 3.337-10.142 3.575 2.026 6.037 5.793 6.225 10.142zM15.999 3.738c1.801 0 3.51 0.394 5.052 1.093-2.161 3.15-3.341 6.802-3.441 10.636h-3.22c-0.101-3.835-1.281-7.487-3.442-10.636 1.542-0.7 3.251-1.093 5.051-1.093zM9.976 5.326c2.089 2.997 3.235 6.478 3.337 10.142h-9.562c0.186-4.349 2.65-8.117 6.225-10.142zM3.752 16.534h9.572c-0.102 3.666-1.246 7.15-3.336 10.147-3.581-2.024-6.049-5.794-6.236-10.147zM15.999 28.262c-1.8 0-3.509-0.393-5.051-1.093 2.162-3.149 3.341-6.798 3.442-10.634h3.22c0.1 3.837 1.281 7.486 3.441 10.634-1.542 0.7-3.251 1.093-5.052 1.093zM22.009 26.682c-2.089-2.997-3.232-6.481-3.333-10.148h9.572c-0.187 4.354-2.656 8.124-6.239 10.148z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBall);
export default __webpack_public_path__ + "static/media/ball.a939851be4f388b1ffc9bab1da6dd010.svg";
export { ForwardRef as ReactComponent };